export const CLIPBOARD = 'Copy to clipboard';
export const RECIPIENT = 'Recipient(s)';
export const MESSAGE = 'Message';
export const SEND = 'Send by email';
export const TAB_EMAIL = 'Email';
export const TAB_LINK = 'Link';
export const MODAL_TITLE = 'Share Dashboard';
export const SHARE = 'Share';
export const SUCCESS_CLIPBOARD = 'Have successfully copied to clipboard!';
